import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router';
import './CSS/ResetPassword.css'

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const resetPassword = async () => {
        const res = await fetch(`/api/reset-password/${token}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ password })
        });
        const data = await res.json();

        if (data.success) {
            setMessage("Jelszó sikeresen módosítva, átirányítás...");
            setTimeout(() => navigate('/login'), 3000);
        } else {
            setMessage(data.errors);
        }
    };

    return (
        <div className='loginsignup'>
            <div className="loginsignup-container">
                <h1>Új jelszó beállítása</h1>
                <div className="loginsignup-fields">
                    <input type="password" placeholder="Új jelszó" value={password}
                        onChange={(e) => setPassword(e.target.value)} />
                </div>
                <button onClick={resetPassword}>Jelszó módosítása</button>
                <p style={{color:'blueviolet'}}>{message}</p>
            </div>
        </div>
    );
};

export default ResetPassword;
